/*
 * File: feed.constants.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on May 27, 2025 at 9:51 AM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 27, 2025 at 12:48 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Constants
import { MESSAGE_TYPES, STORY_MEDIA_TYPES } from './base.constants';


/**
 * Feed Actions
 */

export const FEED_ACTION_CURATED = 'curated';
export const FEED_ACTION_RECOMMENDED = 'recommended';
export const FEED_ACTION_NEWEST = 'newest';
export const FEED_ACTION_ALPHABETICAL = 'alphabetical';


/**
 * Story Feed Actions
 */

export const STORY_FEED_SORT_BY = [
	FEED_ACTION_CURATED,
	FEED_ACTION_NEWEST
];

export const STORY_FEED_FILTER_MEDIUM = [
	STORY_MEDIA_TYPES.NARRATIVE,
	STORY_MEDIA_TYPES.ARTWORK,
];

export const MESSAGE_FEED_FILTER_MESSAGE_TYPE = [
	MESSAGE_TYPES.HEALING_MESSAGE,
	MESSAGE_TYPES.HOPE_MESSAGE,
	MESSAGE_TYPES.SUPPORT_MESSAGE
];


/**
 * Question Feed Actions
 */

export const QUESTION_FEED_SORT_BY = [
	FEED_ACTION_RECOMMENDED,
	FEED_ACTION_NEWEST
];


/**
 * Resources Feed Actions
 */

export const RESOURCES_FEED_SORT_BY = [
	FEED_ACTION_RECOMMENDED,
	FEED_ACTION_ALPHABETICAL
];
